export enum TypeComponent {
  Create,
  Edit,
}
